export type OrganizationId = "diaria_brasil" | "facilita_lavanderia";

const ORGANIZATION_CAPABILITIES: Record<OrganizationId, ReadonlySet<string>> = {
  diaria_brasil: new Set([
    "distribution.access",
    "distribution.schedules.manage",
    "operations.tasks.execute",
    "maintenance.assign",
    "maintenance.catalog.manage",
    "maintenance.execute",
    "inspections.vehicle",
    "inspections.governance",
    "maintenance.audit",
    "inspections.audit.governance",
    "inspections.audit.vehicle",
  ]),
  facilita_lavanderia: new Set(["laundry.access", "cleaning.access"]),
};

export function organizationsForCapabilities(
  capabilities: readonly string[],
): OrganizationId[] {
  return (
    ["diaria_brasil", "facilita_lavanderia"] as OrganizationId[]
  ).filter((organization) =>
    capabilities.some((capability) =>
      ORGANIZATION_CAPABILITIES[organization].has(capability),
    ),
  );
}
